import { assignFormFieldDisplayOrders } from '../components/wizard-steps/fields-step/helpers/fieldDisplayOrder';
import { FormFieldData } from '../types';
import { FormCreateFieldApi } from '../types/formCreateApi';
import { normalizeFormFieldId } from './mapFormApiFields';

export const sortFormFieldsForApiOrder = (
  fields: FormFieldData[]
): FormFieldData[] => assignFormFieldDisplayOrders(fields);

const findFieldIndex = (
  fields: FormFieldData[],
  target: FormFieldData
): number => {
  const targetId = normalizeFormFieldId(target.id);
  if (targetId) {
    const byId = fields.findIndex(
      (field) => normalizeFormFieldId(field.id) === targetId
    );
    if (byId >= 0) {
      return byId;
    }
  }

  return fields.indexOf(target);
};

export const getFormFieldGlobalDisplayOrder = (
  field: FormFieldData,
  currentFields: FormFieldData[],
  originalFields?: FormFieldData[]
): number => {
  const sortedCurrent = sortFormFieldsForApiOrder(currentFields);
  const currentIndex = findFieldIndex(sortedCurrent, field);
  if (currentIndex >= 0) {
    return currentIndex + 1;
  }

  if (originalFields) {
    const sortedOriginal = sortFormFieldsForApiOrder(originalFields);
    const originalIndex = findFieldIndex(sortedOriginal, field);
    if (originalIndex >= 0) {
      return originalIndex + 1;
    }
  }

  return field.order;
};

export const mapFormFieldsToCreateApi = (
  fields: FormFieldData[],
  mapField: (field: FormFieldData, displayOrder: number) => FormCreateFieldApi
) =>
  sortFormFieldsForApiOrder(fields).map((field, index) =>
    mapField(field, index + 1)
  );
